import React from 'react';
import { Button } from 'antd';
import logoSvg from './assets/logo.svg';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './NotFound.less';

const textMap = {
  notFound: {
    title: '抱歉，页面不小心迷路了！',
    enTitle: 'Page Not Found',
  },
  linkInvalid: {
    title: '无效链接',
    enTitle: '',
  },
};

const InValidPage = ({ history, type = 'notFound' }) => {
  const goBackHome = () => {
    window.location.href = '/home';
  };
  const { title, enTitle } = textMap[type];
  return (
    <div className='notFound'>
      <div className='notFound_logo'>
        <img src={logoSvg} alt='logo' />
      </div>
      <div className='notFound_font'>{title}</div>
      <div className='notFound_smallFont'>{enTitle}</div>
      <div className='notFound_back'>
        <Button onClick={goBackHome}>返回主页</Button>
      </div>
    </div>
  );
};

InValidPage.propTypes = {
  /**
   * 无效页面的类型。不同类型，文案不同
   * 默认：'notFound'
   */
  type: PropTypes.oneOf(['notFound', 'linkInvalid']),
};

export default withRouter(InValidPage);
